import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propArrayShape, propBool, propStr, } from '../../../helpers/custom-prop-types';
import Image from '../Common/Image';
const BackgroundThumbnailRow = (props) => {
    const { className, images: rawImages, isReverse } = props;
    const images = useMemo(() => (isReverse ? rawImages.reverse() : rawImages), [rawImages, isReverse]);
    if (!images.length) {
        return null;
    }
    return (_jsx("div", Object.assign({ className: `background-thumbnail-row ${className}` }, { children: images.map((v) => (_jsx("div", Object.assign({ className: `background-thumbnail-column ${v.className}` }, { children: _jsx(Image, { allowContextMenu: false, alt: '', className: 'background-thumbnail-column-inner', isBackground: true, isDisabledGrayScale: !v.isGrayScale, isGrayScale: v.isGrayScale, isObjectFit: true, src: v.image }) }), v.key))) })));
};
BackgroundThumbnailRow.propTypes = {
    className: propStr(),
    images: propArrayShape(),
    isReverse: propBool(),
};
BackgroundThumbnailRow.defaultProps = {
    className: '',
    images: [],
    isReverse: false,
};
export default BackgroundThumbnailRow;
